import type { DynamicClient } from '../../../client/types/DynamicClient';
import { NotWaasWalletAccountError } from '../../../errors/NotWaasWalletAccountError';
import { getWalletProviderFromWalletAccount } from '../../wallets/utils/getWalletProviderFromWalletAccount';
import type { WalletAccount } from '../../wallets/walletAccount';
import { isWaasWalletProvider } from '../isWaasWalletProvider';
import type { WaasWalletProvider } from '../waas.types';

type GetWalletProviderFromWalletAccountParams = {
  walletAccount: WalletAccount;
};

export const getWaasWalletProviderFromWalletAccount = (
  { walletAccount }: GetWalletProviderFromWalletAccountParams,
  client: DynamicClient
): WaasWalletProvider => {
  const walletProvider = getWalletProviderFromWalletAccount(
    { walletAccount },
    client
  );

  if (!isWaasWalletProvider(walletProvider)) {
    throw new NotWaasWalletAccountError({
      walletAddress: walletAccount.address,
    });
  }

  return walletProvider;
};
